import { atom, useAtom } from "jotai"

const hasHydrated = atom(false)
hasHydrated.onMount = (set) => set(true)

export const useHasHydrated = (): boolean => useAtom(hasHydrated)[0]
